export function PaneFooter({ children }: { children: React.ReactNode }) {
    return (
        <footer className="z-2 flex shrink-0 items-center gap-2 bg-sidebar-bg px-4 py-2.5 elev-pane-foot">
            {children}
        </footer>
    );
}
